import React from 'react';
import {
    CREATE_CUSTOMERS,
    CUSTOMERS, FETCH_ALL_CUSTOMERS,
    FETCH_CUSTOMER,
    FETCH_CUSTOMERS,
    PUT_CUSTOMER,
    UPDATE_CUSTOMER,
    UPDATE_CUSTOMERS,
    UPLOAD_CUSTOMER_DOCUMENT,
    putCustomer,
    setCustomers
} from '../../actions/CustomersActions';
import {API_CALL_ERROR, apiRequest, GET, POST, PUT, API_CALL_SUCCESS} from '../../actions/ApiCallsActions';
import endpoints from '../../../endpoints';

import {addNotification} from '../../actions/NotificationActions';
import {uploadDocument} from '../../../api/network/documentService';
import {addCustomerDocument} from '../../../api/network/businessCustomerService';

export default ({dispatch}) => next => action => {
    next(action);

    const {type, payload} = action;

    // eslint-disable-next-line default-case
    switch (type) {
        case FETCH_CUSTOMERS:
            dispatch(apiRequest(endpoints.businessCustomers(payload.companyId), GET, CUSTOMERS));
            break;
        case FETCH_CUSTOMER: {
            const {companyId, customerId} = payload;
            const url = endpoints.businessCustomer(companyId, customerId);
            dispatch(apiRequest(url, GET, CUSTOMERS));
            break;
        }
        case FETCH_ALL_CUSTOMERS: {
            const url = endpoints.allBusinessCustomers;
            dispatch(apiRequest(url, GET, CUSTOMERS));
            break;
        }
        case CREATE_CUSTOMERS: {
            const {companyId, data} = payload;
            const url = endpoints.businessCustomersBulk(companyId);
            const config = {headers: {'Content-Type': 'application/json'}};

            dispatch(apiRequest(url, POST, type, data, config));
            break;
        }
        case UPDATE_CUSTOMER: {
            const {data} = action.payload;
            const {companyId, id: customerId} = data;

            const url = endpoints.businessCustomer(companyId, customerId);
            const config = {headers: {'Content-Type': 'application/json'}};

            dispatch(apiRequest(url, PUT, type, data, config));
            break;
        }
        case UPLOAD_CUSTOMER_DOCUMENT: {
            const {companyId, customerId, data} = payload;
            const {formData} = data;

            uploadDocument(formData).then(result => {
                const {id: documentId} = result;
                console.log('uploadDocument result', documentId);
            }).catch(error => dispatch(addNotification('Failed to update Document', 'error')));
            break;
        }
        case `${UPDATE_CUSTOMER} ${API_CALL_SUCCESS}`: {
            const {data} = payload;
            dispatch(putCustomer(data));
            break;
        }
        case `${UPDATE_CUSTOMER} ${API_CALL_ERROR}`: {
            dispatch(addNotification('Failed to update Customer', 'error'));
            break;
        }
        case `${CUSTOMERS} ${API_CALL_SUCCESS}`: {
            const {data} = payload;
            // set customers

            //TODO normalize customer data
            dispatch(setCustomers(data));
            break;
        }
        case `${CUSTOMERS} ${API_CALL_ERROR}`: {
            dispatch(addNotification('Failed to get Customers', 'error'));
            break;
        }
        case `${CREATE_CUSTOMERS} ${API_CALL_SUCCESS}`: {
            // TODO dispatch insert invent
        }
    }
};
